const SESSION_KEY_VALUE = 'locale';
const DEFAULT_LOCALE_VALUE = 'en';

export function setLocale({ SESSION_KEY = SESSION_KEY_VALUE, value = 'en' }) {
  sessionStorage.setItem(SESSION_KEY, value);
}

export function getLocale({
  SUPPORTED_LOCALES = [DEFAULT_LOCALE_VALUE],
  SESSION_KEY = SESSION_KEY_VALUE,
  DEFAULT_LOCALE = DEFAULT_LOCALE_VALUE
}) {
  const savedLocale = sessionStorage.getItem(SESSION_KEY);

  if (savedLocale) {
    return savedLocale;
  }

  const browserLang = navigator?.language?.substring(0, 2);

  if (SUPPORTED_LOCALES.includes(browserLang)) {
    setLocale({ SESSION_KEY, value: browserLang });
    return browserLang;
  }

  setLocale({ SESSION_KEY, value: DEFAULT_LOCALE });
  return DEFAULT_LOCALE;
}
